/*
 * Copyright 2019 WeBank
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export default {
  name: "Workbench",
  // 规范模块监测什么事件
  events: [
    "Workbench:add",
    "Workbench:deleteDirOrFile",
    "Workbench:openFile",
    "Workbench:pasteInEditor",
    "Workbench:saveAs",
    "Workbench:updateTab",
    "Workbench:setResult",
    "Workbench:checkExist",
    "Workbench:getWorksLangList",
    "Workbench:setEditorPanelSize",
    "Workbench:setTabPanelSize",
    "Workbench:setParseAction",
    "Workbench:removeWork",
    "Workbench:save",
    "Workbench:onLine",
    "Workbench:updateScript"
  ],
  // 规范模块能够触发什么事件
  dispatchs: {
    Workbench: [
      "saveAs",
      "add",
      "openFile",
      "checkExist",
      "setEditorPanelSize",
      "setTabPanelSize",
      "setParseAction",
      "resetScriptData",
      "removeWork",
      "save",
      "updateTab",
      "onLine",
      "updateScript"
    ],
    apiSidebar: ["refresh","getTreeList","updateLeafName"],
  },
  data: {
    API_PATH:
      process.env.VUE_APP_MN_CONFIG_PREFIX ||
      `//${window.location.host}/api/rest_j/v1/`,
    BI_API_PATH: "BI_PREFIX",
  },
  component: () => import("./container.vue"),
  config: {},
};
